import { OnboardingStepEnum } from "../../enums/onboarding-step.enum"

export const onboardingEnumsToRouteMap = {
    // New simplified flow — personal-information is the first post-registration step
    [OnboardingStepEnum.STAFFER_DISPLAY_PICTURE_SIGNUP]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.STAFFER_SKILLS]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_SUBMIT_PROFILE]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_HOME]: '/talent-dashboard/home',
    [OnboardingStepEnum.STAFFER_ONBOARDING_DASHBOARD]: '/onboarding-staffer/onboarding-dashboard',

    // Legacy steps — map to personal-information or onboarding-dashboard
    [OnboardingStepEnum.STAFFER_EXPERTISE]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.CONTRACTOR_INFORMATION]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.STAFFER_INSTRUCTION]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.STAFFER_GETREADY]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.STAFFER_PERSONAL_INFORMATION]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.STAFFER_CONTRACT]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.STAFFER_PROFESSIONAL_INFORMATION]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_LICENSE]: '/onboarding-staffer/personal-information',
    [OnboardingStepEnum.STAFFER_RESUME_UPLOAD]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_QUIZ]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_CERTIFICATES]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_VSS_ATTESTATION]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_SET_SKILLS_RATE]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_ADD_REFERENCE]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_ADD_BACKGROUND_CHECK]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_ADD_BACKGROUND_CHECK_CPY]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_PENDING_STEPS]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_UPLOAD_EQUIPMENT]: '/onboarding-staffer/onboarding-dashboard',
    [OnboardingStepEnum.STAFFER_PRIVACY_POLICY]: '/onboarding-staffer/onboarding-dashboard',
}
